import { DemandAdjustmentTargets } from "../../types/demand-factor.type";
import { joinLabels, labelsOf } from "./constants";
import { OverlapNames } from "./demandFactorOverlap";

export interface TargetNames extends OverlapNames {
  productNameByCode: Map<string, string>;
}

export interface TargetChipLabel {
  level: keyof DemandAdjustmentTargets;
  /** Short enough for a table cell. */
  label: string;
  /** Every name at the level, for the hover text. */
  fullText: string;
}

/**
 * One chip per level the row narrows, in the order the form lists them. A row that narrows
 * nothing reaches every store and gets no chips — the caller shows "ทั้งหมด".
 */
export const buildTargetChipLabels = (
  targets: DemandAdjustmentTargets,
  names: TargetNames,
): TargetChipLabel[] => {
  const levels: {
    level: keyof DemandAdjustmentTargets;
    labels: string[];
    describe: (labels: string[]) => string;
  }[] = [
    {
      level: "target_branch",
      labels: targets.target_branch,
      describe: (labels) => `สาขา ${joinLabels(labels)}`,
    },
    {
      level: "target_route",
      labels: targets.target_route,
      describe: (labels) => `สาย ${joinLabels(labels)}`,
    },
    {
      level: "target_customer_group",
      labels: labelsOf(targets.target_customer_group, names.groupNameByCode),
      describe: (labels) => `กลุ่ม ${joinLabels(labels)}`,
    },
    {
      level: "target_channel",
      labels: labelsOf(targets.target_channel, names.channelNameByCode),
      describe: (labels) => `ช่องทาง ${joinLabels(labels)}`,
    },
    {
      level: "exclude_channel",
      labels: labelsOf(targets.exclude_channel, names.channelNameByCode),
      describe: (labels) => `ยกเว้น: ${joinLabels(labels)}`,
    },
    {
      level: "target_product_code",
      labels: labelsOf(targets.target_product_code, names.productNameByCode),
      describe: (labels) => `สินค้า ${labels.length} รายการ`,
    },
  ];

  return levels
    .filter(({ labels }) => labels.length > 0)
    .map(({ level, labels, describe }) => ({
      level,
      label: describe(labels),
      fullText: labels.join(", "),
    }));
};
